import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Footer } from "./webcomponents/Footer";
import { HomePage } from "./webcomponents/HomePage";
import { LoginPage } from "./webcomponents/auth/LoginPage";
import { SignUpPage } from "./webcomponents/auth/SignUpPage";
import { PatientDashboard } from "./webcomponents/patient/PatientDashboard";
import { ProviderDashboard } from "./webcomponents/provider/ProviderDashboard";
import { FacilityDashboard } from "./webcomponents/facility/FacilityDashboard";
import { AdminDashboard } from "./webcomponents/admin/AdminDashboard";
import { ProviderDirectory } from "./webcomponents/ProviderDirectory";
import { TelehealthBooking } from "./webcomponents/TelehealthBooking";
import { AboutUs } from "./webcomponents/AboutUs";
import {ForPatients} from "./webcomponents/ForPatients";
import { ForFacilities } from "./webcomponents/ForFacilities";
import { ContactPage } from "./webcomponents/ContactPage";
import { DesignShowcase } from "./webcomponents/DesignShowcase";
import { MedicalDashboard } from "./webcomponents/MedicalDashboard";
import { Toaster } from "sonner";
import { WebNavbar } from "./webcomponents/WebNavbar";
import { AuthProvider, useAuth } from "./webcomponents/AuthContext";
import ProviderViewDetails from "./webcomponents/ProviderViewDetails";

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-blue-600"></div>
      </div>
    );
  }

  if (!user || !allowedRoles.includes(user.role)) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

const LandingApp = () => {
  const { user } = useAuth();

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <WebNavbar />
      <main className="flex-1">
        {/* DO NOT wrap Routes in <Router> here */}
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/for-patients" element={<ForPatients />} />
          <Route path="/for-facilities" element={<ForFacilities />} />
          <Route path="/providers" element={<ProviderDirectory />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/design-showcase" element={<DesignShowcase />} />
          <Route path="/medical-dashboard" element={<MedicalDashboard />} />
          <Route path="/Provider-View-Details" element={<ProviderViewDetails />} />
          
          {/* Authenticated Dashboards */}
          <Route
            path="/patient/dashboard"
            element={
              <ProtectedRoute allowedRoles={["patient"]}>
                <PatientDashboard />
              </ProtectedRoute>
            }
          />
          <Route path="booking/telehealth" element={<TelehealthBooking />} />
          <Route
            path="/provider/dashboard"
            element={
              <ProtectedRoute allowedRoles={["provider"]}>
                <ProviderDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/facility/dashboard"
            element={
              <ProtectedRoute allowedRoles={["facility"]}>
                <FacilityDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/dashboard"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              user ? (
                <Navigate to={`/${user.role}/dashboard`} replace />
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
          {/* Catch-all */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <Footer />
      <Toaster position="top-right" />
    </div>
  );
};

export default LandingApp;

